import React, { useEffect, useState,useCallback,
    useRef,
    StrictMode, } from "react";
  import Sidebar from "../../components/Sidebar";
  import { useSelector, useDispatch } from "react-redux";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { apiUrl } from "../../config/Config";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
  import { Button, Modal } from "react-bootstrap";
  import "bootstrap/dist/css/bootstrap.min.css";
  import Overlay from "../../components/Overlay";
  import { useMemo } from 'react';
  import { AgGridReact } from "@ag-grid-community/react";
  import "@ag-grid-community/styles/ag-grid.css";
  import "@ag-grid-community/styles/ag-theme-quartz.css";
  import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
  import { ModuleRegistry } from "@ag-grid-community/core";
  import Spinner from "react-activity/dist/Spinner";
  import LMSSidebar from "../../components/LMSSidebar";
  ModuleRegistry.registerModules([ClientSideRowModelModule]);
  
  const CompaniesData = () => {
    const formatsarr = [
      {"name": "FirstnameLastname", "value": "FirstnameLastname"},
      {"name": "Firstname.Lastname", "value": "Firstname.Lastname"},
      {"name": "Firstname_Lastname", "value": "Firstname_Lastname"},
      {"name": "Firstname-Lastname", "value": "Firstname-Lastname"},
      {"name": "FirstinitalLastName", "value": "FirstinitalLastName"},
      {"name": "FirstInitial.Lastname", "value": "FirstInitial.Lastname"},
      {"name": "FirstInitial-Lastname", "value": "FirstInitial-Lastname"},
      {"name": "FirstInitial_Lastname", "value": "FirstInitial_Lastname"},
      {"name": "FirstnameLastinitial", "value": "FirstnameLastinitial"},
      {"name": "Firstname.Lastinitial", "value": "Firstname.Lastinitial"},
      {"name": "Firstname_Lastinitial", "value": "Firstname_Lastinitial"},
      {"name": "Firstname-Lastinitial", "value": "Firstname-Lastinitial"},
      {"name": "FirstInitialLastinitial", "value": "FirstInitialLastinitial"},
      {"name": "Firstname", "value": "Firstname"},
      {"name": "firstTwolettersofFirstnameLastname", "value": "firstTwolettersofFirstnameLastname"},
      {"name": "LastnameFirstname", "value": "LastnameFirstname"},
      {"name": "Lastname.Firstname", "value": "Lastname.Firstname"},
      {"name": "Lastname_Firstname", "value": "Lastname_Firstname"},
      {"name": "Lastname-Firstname", "value": "Lastname-Firstname"},
      {"name": "LastinitialFirstname", "value": "LastinitialFirstname"},
      {"name": "Lastinitial.Firstname", "value": "Lastinitial.Firstname"},
      {"name": "Lastinitial-Firstname", "value": "Lastinitial-Firstname"},
      {"name": "Lastinitial_Firstname", "value": "Lastinitial_Firstname"},
      {"name": "LastnameFirstinitial", "value": "LastnameFirstinitial"},
      {"name": "Lastname.Firstinitial", "value": "Lastname.Firstinitial"},
      {"name": "LastinitialFirstIntial", "value": "LastinitialFirstIntial"},
      {"name": "Lastname", "value": "Lastname"},
      {"name": "LastnameFirstinitialMiddleinitial", "value": "LastnameFirstinitialMiddleinitial"},
      {"name": "Last.FirstinitialMiddleinitial", "value": "Last.FirstinitialMiddleinitial"},
      {"name": "FirstInitialMidInitialLastname", "value": "FirstInitialMidInitialLastname"},
      {"name": "FirstInitial.MidInitial.Lastname", "value": "FirstInitial.MidInitial.Lastname"},
      {"name": "Firstname.MidInitial.Lastname", "value": "Firstname.MidInitial.Lastname"},
      {"name": "First_Middleinitial_Last", "value": "First_Middleinitial_Last"},
      {"name": "FirstnameMidInitialLastInitial", "value": "FirstnameMidInitialLastInitial"},
      {"name": "Firstnitial.Lastinitial", "value": "Firstnitial.Lastinitial"},
      {"name": "Lastinitial.Firstnitial", "value": "Lastinitial.Firstnitial"},
      {"name": "Lastname-FirstInitial", "value": "Lastname-FirstInitial"},
      {"name": "Lastname_FirstInitial", "value": "Lastname_FirstInitial"},
    ]
    let navigate = useNavigate();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const paginationPageSizeSelector = useMemo(() => {
      return [10, 20, 50, 100];
    }, []);
  
    const defaultColDef = {
      // flex: 1,
    };

    const [showimportmodal, setshowimportmodal] = useState(false);
    const [selectedfile, setselectedfile] = useState(null);
    const [selectedimages, setselectedimages] = useState([]);
    const [bulkuploadloading, setbulkuploadloading] = useState(false);

    const [showcompanymodal, setshowcompanymodal] = useState(false);
    const [companyname, setcompanyname] = useState("");
    const [domain1, setdomain1] = useState("");
    const [domain2, setdomain2] = useState("");
    const [format1, setformat1] = useState("");
    const [format2, setformat2] = useState("");
    const [format3, setformat3] = useState("");
    const [companyloading, setcompanyloading] = useState(false);

    const [selectedcompanyid, setselectedcompanyid] = useState(0);
    const selectedcompanyidRef = useRef(0);
    selectedcompanyidRef.current = selectedcompanyid;

    const [showeditcompanymodal, setshoweditcompanymodal] = useState(false);


    const handleuploadexcel = async() => {
      setbulkuploadloading(true);
      const formData = new FormData();
      formData.append('file', selectedfile);
  
      console.log('formData >>',formData);
  
      const headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "uploadcompanyconfigs", formData, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            setshowimportmodal(false);
           fetchallcourses();
            // setshowloding(false);
            setbulkuploadloading(false);
          } else {
            alert(res.data.message);
            // setshowloding(false);
            setbulkuploadloading(false);
          }
        })
        .catch((err) => {
          // setshowloding(false);
          setbulkuploadloading(false);
          alert(err.message);
        });
        setbulkuploadloading(false);
    }

    const handlesubmitcompanyconfig = async() => {
      setcompanyloading(true);
      var data = {
        "name": companyname,
        "domain1": domain1,
        "domain2": domain2,
        "format1": format1,
        "format2": format2,
        "format3": format3,
      }
  
      const headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "submitcompanyconfig", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            setshowcompanymodal(false);
            fetchallcourses();
            setcompanyname("");
            setdomain1("");
            setdomain2("");
            setformat1("");
            setformat2("");
            setformat3("");
            // setshowloding(false);
            setcompanyloading(false);
          } else {
            alert(res.data.message);
            // setshowloding(false);
            setcompanyloading(false);
          }
        })
        .catch((err) => {
          // setshowloding(false);
          setcompanyloading(false);
          alert(err.message);
        });
        setcompanyloading(false);
    }

    const handlesubmitcompanyconfig1 = async() => {
        setcompanyloading(true);
        var data = {
            "id": selectedcompanyidRef.current,
          "name": companyname,
          "domain1": domain1,
          "domain2": domain2,
          "format1": format1,
          "format2": format2,
          "format3": format3,
        }
    
        const headers = {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "updatecompanyconfig", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              setshoweditcompanymodal(false);
              fetchallcourses();
              setcompanyname("");
              setdomain1("");
              setdomain2("");
              setformat1("");
              setformat2("");
              setformat3("");
              // setshowloding(false);
              setcompanyloading(false);
            } else {
              alert(res.data.message);
              // setshowloding(false);
              setcompanyloading(false);
            }
          })
          .catch((err) => {
            // setshowloding(false);
            setcompanyloading(false);
            alert(err.message);
          });
          setcompanyloading(false);
      }
  
    const clickhandle = () =>  {
      console.log('Mission Launched')
    }

    const editlocation = async(data) => {
        setselectedcompanyid(data?.id);
        setcompanyname(data?.name);
        setdomain1(data?.domain1);
        setdomain2(data?.domain2);
        setformat1(data?.format1);
        setformat2(data?.format2);
        setformat3(data?.format3);
        setshoweditcompanymodal(true);
      }
    
    const fetchallcourses = async () => {
      setshowloding(true);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .get(apiUrl + "getallcompanyconfiglist", headers)
        .then((res) => {
          if (res.data.status == "success") {
            console.log('getallcompanyconfiglist >>', res.data);
            var prevdata = res.data.data;
            if(prevdata?.length > 0) {
              var columnsarr = [];
              var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'status','category'];
              var hidefilters = [];
              var columns = Object.keys(prevdata[0]);
              for(var i = 0; i < columns?.length;i++) {
                if(!hidecolumns.includes(columns[i])) {
                  var obj = {};
                  obj.field = columns[i];
                  if(!hidefilters.includes(columns[i])) {
                    obj.filter = true;
                    obj.filterParams = {
                        filterOptions: ["contains"],
                        maxNumConditions: 1,
                    };
                  }
                  console.log('obj >>', obj)
                  columnsarr.push(obj);
                }
              }
              //edit
                            var editobj = 
                            {
                              field: "edit",
                              headerName: "Edit",
                              cellRenderer: (props) => {
                                
                                return (
                                  <div
                                        onClick={() => {
                                          editlocation(props?.data);
                                          // console.log('props >>', props?.data);
                                        }}
                                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPenToSquare}
                                          className="sidebaricons"
                                          style={{ color: "blue" }}
                                        />
                                      </div>
                                )
                              },
                              cellRendererParams: {
                                onClick: clickhandle,
                              },
                            }
                            columnsarr.push(editobj);
              //delete
            //   var deleteobj = 
            //   {
            //     field: "delete",
            //     headerName: "Delete",
            //     cellRenderer: (props) => {
                  
            //       return (
            //         <div
            //               onClick={() => {
            //                 deletecourse(props?.data?.id);
            //                 // console.log('props >>', props?.data);
            //               }}
            //               style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
            //             >
            //               <FontAwesomeIcon
            //                 icon={faTrash}
            //                 className="sidebaricons"
            //                 style={{ color: "red" }}
            //               />
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(deleteobj);
              setColDefs(columnsarr);
              setRowData(prevdata);
            } else {
                setColDefs([]);
              setRowData([]);
            }
            
            // setcoursesdata(res.data.data);
          } else {
            // alert(res.data.message);
          }
        })
        .catch((err) => {
          alert(err.message);
        });
        setshowloding(false);
    };
    const deletecourse = async (id) => {
      const result = window.confirm("Are you sure you want to delete this registration ?");
      if (result) {
        var data = JSON.stringify({
          id: id,
        });
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios  
          .post(apiUrl + "deletenewregister", data, headers)
          .then((res) => {
            if (res.data.status == "success") {
              fetchallcourses();
            } else {
            }
          })
          .catch((err) => {
            alert(err.message);
          });
      } else {
        // User clicked Cancel or closed the dialog
        console.log("User clicked Cancel");
      }
    };
  
   
    useEffect(() => {
      if (userdata && Object.keys(userdata).length > 0) {
        //   fetchdata();
        fetchallcourses();
      } else {
        navigate("/newadminlogin");
      }
    }, []);
    return (
      <div className="HomeMain">
        <Overlay showloader={showloding} />
        <div className="sidebar-div">
          <LMSSidebar name={"Admin"} />
        </div>
        <div className="main-layout">
          <div className="mainDiv">
            <p className="oneplaceHead">Company Config List</p>
            <br />
            <div className="tablebuttondiv tablebuttondivpage">
            <Link
                onClick={() => {
                    setselectedfile("");
                    setshowimportmodal(true);
                }}
                className="btndiv webadminmaindiv"
              >
                <p>{"Upload"}</p>
              </Link>
              <Link
                onClick={() => {
                    setcompanyname("");
                    setdomain1("");
                    setdomain2("");
                    setformat1("");
                    setformat2("");
                    setformat3("");
                  setshowcompanymodal(true);
                }}
                className="btndiv webadminmaindiv"
                style={{marginLeft: 20}}
              >
                <p>{"Company Configure"}</p>
              </Link>
            </div>

            <div
              className={"ag-theme-quartz"}
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                // modules={AllModules}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                suppressRowClickSelection={true}
                groupSelectsChildren={true}
                rowSelection={"multiple"}
                pagination={true}
                paginationPageSize={10}
                paginationPageSizeSelector={paginationPageSizeSelector}
                // onGridReady={onGridReady}
              />
            </div>
            <br />
          </div>
        </div>


        {/* Company Configure Modal */}
        <Modal
          show={showcompanymodal}
          onHide={() => setshowcompanymodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>
              Company Name Config
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="row">
                <div className="col-md-12">
                  <label className="admin-label">Company name</label>
                  <input
                    type="text"
                    value={companyname}
                    onChange={(t) => {
                      setcompanyname(t.target.value);
                    }}
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Domain1</label>
                  <input
                    type="text"
                    value={domain1}
                    onChange={(t) => {
                      setdomain1(t.target.value);
                    }}
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Domain2</label>
                  <input
                    type="text"
                    value={domain2}
                    onChange={(t) => {
                      setdomain2(t.target.value);
                    }}
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Format1</label>
                  <select className="form-control admininput" value={format1} onChange={(t) => {setformat1(t.target.value)}}>
                    <option value={""} selected disabled>Select Format</option>
                    {
                      formatsarr?.map((item, index) => {
                        return (
                          <option key={index} value={item?.value}>{item?.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Format2</label>
                  <select className="form-control admininput" value={format2} onChange={(t) => {setformat2(t.target.value)}}>
                    <option value={""} selected disabled>Select Format</option>
                    {
                      formatsarr?.map((item, index) => {
                        return (
                          <option key={index} value={item?.value}>{item?.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Format3</label>
                  <select className="form-control admininput" value={format3} onChange={(t) => {setformat3(t.target.value)}}>
                    <option value={""} selected disabled>Select Format</option>
                    {
                      formatsarr?.map((item, index) => {
                        return (
                          <option key={index} value={item?.value}>{item?.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12">
                  <div
                    className="webadmin-modalbtn"
                    onClick={() => {
                      handlesubmitcompanyconfig();
                    }}
                  >
                    <p>
                      {companyloading ? (
                        <Spinner size={15} className="spinnerCenter" />
                      ) : (
                        "Submit"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Company Configure Edit Modal */}
        <Modal
          show={showeditcompanymodal}
          onHide={() => setshoweditcompanymodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>
              Company Name Config
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="row">
                <div className="col-md-12">
                  <label className="admin-label">Company name</label>
                  <input
                    type="text"
                    value={companyname}
                    onChange={(t) => {
                      setcompanyname(t.target.value);
                    }}
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Domain1</label>
                  <input
                    type="text"
                    value={domain1}
                    onChange={(t) => {
                      setdomain1(t.target.value);
                    }}
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Domain2</label>
                  <input
                    type="text"
                    value={domain2}
                    onChange={(t) => {
                      setdomain2(t.target.value);
                    }}
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Format1</label>
                  <select className="form-control admininput" value={format1} onChange={(t) => {setformat1(t.target.value)}}>
                    <option value={""} selected disabled>Select Format</option>
                    {
                      formatsarr?.map((item, index) => {
                        return (
                          <option key={index} value={item?.value}>{item?.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Format2</label>
                  <select className="form-control admininput" value={format2} onChange={(t) => {setformat2(t.target.value)}}>
                    <option value={""} selected disabled>Select Format</option>
                    {
                      formatsarr?.map((item, index) => {
                        return (
                          <option key={index} value={item?.value}>{item?.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12 mt-2">
                  <label className="admin-label">Format3</label>
                  <select className="form-control admininput" value={format3} onChange={(t) => {setformat3(t.target.value)}}>
                    <option value={""} selected disabled>Select Format</option>
                    {
                      formatsarr?.map((item, index) => {
                        return (
                          <option key={index} value={item?.value}>{item?.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12">
                  <div
                    className="webadmin-modalbtn"
                    onClick={() => {
                      handlesubmitcompanyconfig1();
                    }}
                  >
                    <p>
                      {companyloading ? (
                        <Spinner size={15} className="spinnerCenter" />
                      ) : (
                        "Submit"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Import Config Modal */}
        <Modal
          show={showimportmodal}
          onHide={() => setshowimportmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Bulk Upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="row">
                <div className="col-md-12">
                  <label className="admin-label">Upload Excel / CSV</label>
                  <input
                    type="file"
                    onChange={(t) => {
                      setselectedfile(t.target.files[0]);
                    }}
                    accept=".csv"
                    className="form-control admininput"
                  />
                </div>
                <div className="col-md-12">
                  <div
                    className="webadmin-modalbtn"
                    onClick={() => {
                      handleuploadexcel();
                    }}
                  >
                    <p>
                      {bulkuploadloading ? (
                        <Spinner size={15} className="spinnerCenter" />
                      ) : (
                        "Submit"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  };
  
  export default CompaniesData;
  